import { Component, Input, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'conexao-item',
  templateUrl: './conexao-item.component.html',
  styleUrls: ['./conexao-item.component.scss']
})
export class ConexaoItemComponent implements OnInit {

  @Input("data") data:any = null;
  public prefixo          = "web";
  public numero           = null;

  constructor(
    private deviceService: DeviceDetectorService
  ){}

  /***
   * 
   * Open
   * 
   ***/
  _open(){

    window.open("https://"+this.prefixo+".whatsapp.com/send?phone="+this.numero,"__blank");

  }
  /**
   * 
   * Set número
   * 
   */
  setNumero(){
    
    if(this.data.whatsapp_ativo){
      let telefone = this.data.whatsapp.replace("(","").replace(")","").replace("-","").replace(" ","");
      this.numero = "55"+telefone;
    }

  }
  /***
   * 
   * Init
   * 
   **/
  ngOnInit():void{
    this.setNumero();
    this.prefixo = this.deviceService.isDesktop() ? "web" : "api";
  }

}
